import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['badge', 'preferredGender'];
  static values = { selected: Array };

  connect() {
    if (this.hasPreferredGenderTarget) {
      this.selectedValue = this.preferredGenderTarget.value.split(',') || [];
    }
    this.updateUI();
  }

  select(event) {
    event.preventDefault();

    const badge = event.currentTarget;
    const gender = badge.dataset.gender;

    // Toggle selection
    if (this.selectedValue.includes(gender)) {
      // If already selected, deselect
      this.selectedValue = this.selectedValue.filter((item) => item !== gender);
    } else {
      // Select the new gender (and deselect others)
      this.selectedValue = [gender];
    }

    this.updateHiddenInput();
    this.updateUI();
  }

  updateHiddenInput() {
    if (this.hasPreferredGenderTarget) {
      this.preferredGenderTarget.value = this.selectedValue.join(',');
    }
  }

  updateUI() {
    this.badgeTargets.forEach((badge) => {
      const isSelected = this.selectedValue.includes(badge.dataset.gender);
      const badgeDiv = badge.querySelector('div'); // Target the inner <div>
      const plusIcon = badge.querySelector('#plus-icon');

      if (isSelected) {
        // Apply selected styling
        badgeDiv.classList.add('bg-primary', 'text-white');
        badgeDiv.classList.remove('border-double-1');
        badgeDiv.classList.remove('text-black');

        // Add rotate-plus to the icon
        plusIcon.classList.add('rotate-plus');
      } else {
        // Remove selected styling
        badgeDiv.classList.remove('bg-primary', 'text-white');
        badgeDiv.classList.add('text-black', 'border-double-1');

        // Remove rotate-plus from the icon
        plusIcon.classList.remove('rotate-plus');
      }
    });
  }
}
